/* eslint-disable  */

import { APIClient } from "./_api";
const endpoint = "/User";

export function getAll(values) {
  return APIClient.post(`${endpoint}/users/filter`, values);
}

export function getAllUserReferral(userId) {
  return APIClient.get(`${endpoint}/referral/${userId}`);
}
export function getAllInActiveAgents(query) {
  return APIClient.post(`${endpoint}/inactiveSaleAgents`, query);
}

export function getAllAgent(values) {
  return APIClient.post(`/userPage/filter`, values);
}
export function getAllSaleAgent(values) {
  return APIClient.get(`${endpoint}/saleAgent`, values);
}

export function createAgentbyAdmin(values) {
  return APIClient.post(`/userPage/create/byAdmin`, values);
}

export function getAllUserNoFilter() {
  return APIClient.get(`${endpoint}/users`);
}
export function getAllMenu(values) {
  return APIClient.get(`${endpoint}/menu`, values);
}

export function getAllSaleManager() {
  return APIClient.get(`${endpoint}/saleManager`);
}

export function getAllDeleted(values) {
  return APIClient.post(`${endpoint}/users/deleted/filter`, values);
}
export function getAllRecruiterUser(values) {
  return APIClient.get(`${endpoint}/recruiterUser/users/${values}`);
}

export function editRecruiter(userId, values) {
  return APIClient.put(`${endpoint}/parent/${userId}`, values);
}

export function editByAdmin(values) {
  return APIClient.put(`${endpoint}/admin`, values);
}
export function editUserAdminAccount(values) {
  return APIClient.put(`${endpoint}/users/updateBankAccount`, values);
}

export function edit(values) {
  return APIClient.put(`${endpoint}`, values);
}
export function postUserAgent(values) {
  return APIClient.post(`/UserPage`, values);
}
export function postUserAgentAdmin(values) {
  return APIClient.post(`/UserPage/create/byAdmin`, values);
}
export function editUserAgent(values, id) {
  return APIClient.put(`/UserPage/${id}`, values);
}
export function getUserAgent(id) {
  return APIClient.get(`/UserPage/id/${id}`);
}

export function avatar(values) {
  return APIClient.put(`${endpoint}/avatar`, values);
}

export function getAllDriver() {
  return APIClient.get(`${endpoint}/driver`);
}

export function deleteItem(id) {
  return APIClient.delete(`${endpoint}/admin/${id}`);
}
export function deleteUserAgentPage(id) {
  return APIClient.delete(`/UserPage/${id}`);
}

export function unbanItem(id) {
  return APIClient.put(`${endpoint}/restore/${id}`);
}

export function activeUser(values) {
  return APIClient.put(`${endpoint}/recruiterUser/accept`, values);
}

export function declineUser(values) {
  return APIClient.put(
    `${endpoint}/recruiterUser/decline/${values.userId}`,
    values.data
  );
}

export function banUser(values) {
  return APIClient.post(`/BanList`, values);
}

// AgentAssistant
export function getAllAgentAssistant(values) {
  //filter
  // return APIClient.post(`/AgentAssistant/filter`, values);
  return APIClient.get(`/AgentAssistant`);
}

export function createAgentAssistant(values) {
  return APIClient.post(`/AgentAssistant`, values);
}

export function deleteAgentAssistant(id) {
  return APIClient.delete(`/AgentAssistant/${id}`);
}

export function create(value, func) {
  const bodyFormData = new FormData();
  for (const key in value) {
    bodyFormData.append(key, value[key]);
  }
  return APIClient.post(`${endpoint}/create`, bodyFormData, {
    onUploadProgress(progress) {
      if (func) {
        func(progress);
      }
    },
  });
}

export function userFillContract(values) {
  return APIClient.post(`${endpoint}/contract/fill`, values);
}

export function userFillContractCommission(values) {
  return APIClient.post(`${endpoint}/contractCommission/fillContract`, values);
}

export function userImportContract(values) {
  return APIClient.post(
    `${endpoint}/contractCommission/importContract`,
    values
  );
}
export function userChangeStatusContract(values) {
  return APIClient.post(`${endpoint}/contractCommission/changeStatus`, values);
}

export function userApproveContract(values) {
  return APIClient.post(`${endpoint}/contract/approve`, values);
}

export function userRejectContract(values) {
  return APIClient.post(`${endpoint}/contract/reject`, values);
}
